/* SomaEase™ Theme JS – ohne Abhängigkeiten.
   Module: Reveal, Lieferdatum, Sticky-ATC, Tabs/Accordion, Review-Slider, Video-Hero. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll-Reveal ---------- */
  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('.se-reveal:not(.is-inview)');
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-inview');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (n, i) {
      if (!n.style.getPropertyValue('--se-reveal-delay')) {
        var siblings = n.parentElement ? n.parentElement.querySelectorAll(':scope > .se-reveal') : [];
        var idx = Array.prototype.indexOf.call(siblings, n);
        if (idx > 0) n.style.setProperty('--se-reveal-delay', Math.min(idx, 5) * 70 + 'ms');
      }
      io.observe(n);
    });
  }

  /* ---------- Lieferdatum ---------- */
  var MONTHS = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
  var DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  function fmt(d, withDay) {
    var s = d.getDate() + '. ' + MONTHS[d.getMonth()];
    return withDay ? DAYS[d.getDay()] + ', ' + s : s;
  }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-se-delivery]').forEach(function (el) {
      if (el.dataset.seDeliveryDone) return;
      var min = parseInt(el.dataset.seMin || '7', 10);
      var max = parseInt(el.dataset.seMax || '10', 10);
      var business = el.dataset.seBusiness === 'true';
      var cutoff = parseInt(el.dataset.seCutoff || '0', 10);
      var now = new Date();
      var start = new Date(now.getTime());
      if (cutoff && now.getHours() >= cutoff) start.setDate(start.getDate() + 1);
      var a = business ? addBusinessDays(start, min) : new Date(start.getTime() + min * 864e5);
      var b = business ? addBusinessDays(start, max) : new Date(start.getTime() + max * 864e5);
      var tpl = el.dataset.seTemplate || 'Bestelle heute, Lieferung ca. [from] – [to]';
      el.textContent = tpl.replace('[from]', fmt(a, false)).replace('[to]', fmt(b, false));
      el.dataset.seDeliveryDone = '1';
    });
    (root || document).querySelectorAll('[data-se-day]').forEach(function (el) {
      var off = parseInt(el.dataset.seOffset || '0', 10);
      var d = off > 0 ? addBusinessDays(new Date(), off) : new Date();
      el.textContent = (off === 0 ? 'Heute, ' : '') + fmt(d, off !== 0);
    });
    (root || document).querySelectorAll('[data-se-xmas]').forEach(function (el) {
      var raw = el.dataset.seXmasCutoff || '';
      var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return;
      var cutoff = new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59);
      var ok = new Date() <= cutoff;
      var text = ok ? el.dataset.seXmasOk : el.dataset.seXmasLate;
      var target = el.querySelector('[data-se-xmas-text]');
      if (!text) { el.hidden = true; return; }
      if (target) target.textContent = text;
      el.classList.toggle('is-late', !ok);
      el.hidden = false;
    });
  }

  /* ---------- Sticky Add-to-Cart ---------- */
  function initSticky(root) {
    (root || document).querySelectorAll('[data-se-sticky]').forEach(function (bar) {
      if (bar.dataset.seStickyDone) return;
      bar.dataset.seStickyDone = '1';
      var targetSel = bar.dataset.seSticky;
      var target = document.querySelector(targetSel);
      if (!target || !('IntersectionObserver' in window)) return;
      var desktop = bar.classList.contains('se-sticky--desktop');
      var mq = window.matchMedia(desktop ? 'all' : '(max-width: 989px)');
      var btn = bar.querySelector('[data-se-sticky-btn]');
      var formId = bar.dataset.seForm;
      if (btn && formId) {
        btn.addEventListener('click', function () {
          var form = document.getElementById(formId);
          if (!form) return;
          var submit = form.querySelector('[type="submit"]');
          if (submit) submit.click();
          else form.requestSubmit();
        });
      }
      function setVisible(v) {
        bar.classList.toggle('is-visible', v);
        bar.setAttribute('aria-hidden', v ? 'false' : 'true');
        document.body.classList.toggle('se-sticky-active', v);
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!mq.matches) { setVisible(false); return; }
          /* mobil: immer sichtbar, solange der Haupt-Button nicht im Bild ist (auch darunter); Desktop: erst nach dem Vorbeiscrollen */
          var below = window.matchMedia('(max-width: 989px)').matches;
          setVisible(!e.isIntersecting && (below || e.boundingClientRect.top < 0));
        });
      }, { threshold: 0 });
      io.observe(target);
      mq.addEventListener && mq.addEventListener('change', function () { if (!mq.matches) setVisible(false); });
      /* Preis-Sync bei Variantenwechsel */
      var priceSrc = document.querySelector(bar.dataset.sePriceSource || '');
      var priceDst = bar.querySelector('[data-se-sticky-price]');
      if (priceSrc && priceDst && 'MutationObserver' in window) {
        new MutationObserver(function () {
          var sale = priceSrc.querySelector('.price__sale .price-item--sale');
          var reg = priceSrc.querySelector('.price__regular .price-item--regular');
          var cmp = priceSrc.querySelector('.price__sale s');
          var onSale = priceSrc.querySelector('.price--on-sale');
          var cur = (onSale && sale) ? sale.textContent : (reg ? reg.textContent : '');
          var strong = priceDst.querySelector('strong');
          var s = priceDst.querySelector('s');
          if (strong && cur) strong.textContent = cur.trim();
          if (s) { s.textContent = (onSale && cmp) ? cmp.textContent.trim() : ''; s.hidden = !(onSale && cmp); }
        }).observe(priceSrc, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  /* ---------- Geschenk-Sets (Menge + Gesamtpreis im Button) ---------- */
  function initBundles(root) {
    (root || document).querySelectorAll('[data-se-bundles]').forEach(function (box) {
      if (box.dataset.seBundlesDone) return;
      box.dataset.seBundlesDone = '1';
      var qty = box.querySelector('[data-se-bundle-qty]');
      var submit = document.querySelector(box.dataset.seSubmit || '');
      var label = submit ? submit.querySelector('span') : null;
      var base = label ? label.textContent.trim() : '';
      var sticky = document.querySelector('[data-se-sticky-price] strong');
      function apply() {
        var r = box.querySelector('input[type="radio"]:checked');
        if (!r) return;
        if (qty) qty.value = r.value;
        box.querySelectorAll('.se-bundle').forEach(function (l) {
          l.classList.toggle('is-selected', l.contains(r));
        });
        var total = r.dataset.total || '';
        if (label && base && total && !(submit && submit.disabled)) label.textContent = base + ' · ' + total;
        if (sticky && total) sticky.textContent = total;
      }
      box.addEventListener('change', apply);
      apply();
    });
  }

  /* ---------- Warenkorb-Upsell: 2. Gerät hinzufügen (ohne product-form, übersteht Drawer-Re-Render) ---------- */
  function initUpsellAdd() {
    if (document.documentElement.dataset.seUpsellDone) return;
    document.documentElement.dataset.seUpsellDone = '1';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-se-upsell-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      var useDrawer = btn.dataset.context === 'drawer' && drawer && typeof drawer.renderContents === 'function';
      var fd = new FormData();
      fd.append('id', btn.dataset.variant);
      fd.append('quantity', '1');
      if (useDrawer) {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      var err = btn.parentNode.querySelector('.se-cart-upsell__error');
      btn.disabled = true;
      btn.classList.add('loading');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) {
            btn.disabled = false;
            btn.classList.remove('loading');
            if (err) { err.textContent = res.description || res.message || 'Konnte nicht hinzugefügt werden.'; err.hidden = false; }
            return;
          }
          if (useDrawer) drawer.renderContents(res);
          else window.location.reload();
        })
        .catch(function () { window.location.href = '/cart'; });
    });
  }

  /* ---------- Warenkorb öffnet sich nach „In den Warenkorb“ IMMER ----------
     Dawn veröffentlicht nach erfolgreichem Hinzufügen ein cart-update-Event und rendert dann den Drawer.
     Scheitert das (z. B. in In-App-Browsern von Instagram/Facebook oder älterem Safari), holen wir den
     Drawer frisch vom Server und öffnen ihn selbst. Ohne Drawer geht es direkt zur Warenkorbseite. */
  function seOpenCartDrawer() {
    var d = document.querySelector('cart-drawer');
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    if (!d || typeof d.open !== 'function') { window.location.href = cartUrl; return; }
    if (d.classList.contains('active')) return;
    fetch(window.location.pathname + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        d.classList.remove('is-empty');
        var inner = d.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        var ov = d.querySelector('#CartDrawer-Overlay');
        if (ov && typeof d.close === 'function') ov.addEventListener('click', d.close.bind(d));
        d.open();
      })
      .catch(function () { window.location.href = cartUrl; });
  }
  function initCartOpenGuard() {
    if (document.documentElement.dataset.seCartGuard) return;
    document.documentElement.dataset.seCartGuard = '1';
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
          if (!e || e.source !== 'product-form') return;
          setTimeout(seOpenCartDrawer, 700);
        });
      }
    } catch (err) {}
  }

  /* ---------- Tabs + Accordion (se-areas) ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-se-tabs]').forEach(function (wrap) {
      if (wrap.dataset.seTabsDone) return;
      wrap.dataset.seTabsDone = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-se-panel]'));
      var summaries = Array.prototype.slice.call(wrap.querySelectorAll('[data-se-summary]'));
      var mq = window.matchMedia('(min-width: 750px)');

      function activate(idx, focus) {
        tabs.forEach(function (t, i) {
          var on = i === idx;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        panels.forEach(function (p, i) { p.classList.toggle('is-active', i === idx); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); activate(n, true); }
        });
      });
      summaries.forEach(function (s) {
        s.addEventListener('click', function () {
          var body = document.getElementById(s.getAttribute('aria-controls'));
          var open = s.getAttribute('aria-expanded') === 'true';
          if (mq.matches) return;
          s.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (body) body.hidden = open;
        });
      });
      function syncMode() {
        if (mq.matches) {
          panels.forEach(function (p) {
            var body = p.querySelector('[data-se-body]');
            if (body) body.hidden = false;
          });
          if (!panels.some(function (p) { return p.classList.contains('is-active'); })) activate(0, false);
        } else {
          summaries.forEach(function (s, i) {
            var body = document.getElementById(s.getAttribute('aria-controls'));
            var open = s.getAttribute('aria-expanded') === 'true';
            if (body) body.hidden = !open;
          });
        }
      }
      syncMode();
      mq.addEventListener && mq.addEventListener('change', syncMode);
    });
  }

  /* ---------- Review-Slider ---------- */
  function initSlider(root) {
    (root || document).querySelectorAll('[data-se-slider]').forEach(function (wrap) {
      if (wrap.dataset.seSliderDone) return;
      wrap.dataset.seSliderDone = '1';
      var track = wrap.querySelector('[data-se-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-se-slide]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.dataset.seSlide === 'next' ? 1 : -1;
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
          track.scrollBy({ left: dir * step, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      function updateBtns() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var prev = wrap.querySelector('[data-se-slide="prev"]');
        var next = wrap.querySelector('[data-se-slide="next"]');
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      track.addEventListener('scroll', updateBtns, { passive: true });
      window.addEventListener('resize', updateBtns);
      updateBtns();
    });
  }

  /* ---------- Video-Hero ---------- */
  function initVideo(root) {
    (root || document).querySelectorAll('[data-se-video]').forEach(function (wrap) {
      if (wrap.dataset.seVideoDone) return;
      wrap.dataset.seVideoDone = '1';
      var video = wrap.querySelector('video');
      var toggle = wrap.querySelector('[data-se-video-toggle]');
      if (!video) return;
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      function setState(playing) {
        if (!toggle) return;
        toggle.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
      }
      if (!reduceMotion && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              var p = video.play();
              if (p && p.catch) p.catch(function () { setState(false); });
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.35 });
        io.observe(video);
      }
      video.addEventListener('play', function () { setState(true); });
      video.addEventListener('pause', function () { setState(false); });
      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) video.play(); else video.pause();
        });
      }
    });
  }

  /* ---------- Galerie-Punkte (mobil) ---------- */
  function initGalleryDots(root) {
    (root || document).querySelectorAll('.se-pdp [id^="GalleryViewer-"]').forEach(function (viewer) {
      if (viewer.dataset.seDotsDone) return;
      var list = viewer.querySelector('.product__media-list');
      if (!list) return;
      var items = Array.prototype.slice.call(list.querySelectorAll(':scope > .product__media-item'));
      if (items.length < 2) return;
      viewer.dataset.seDotsDone = '1';
      var dots = document.createElement('ol');
      dots.className = 'se-dots';
      dots.setAttribute('aria-label', 'Bilder');
      items.forEach(function (item, i) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Bild ' + (i + 1) + ' von ' + items.length);
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () {
          list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
        li.appendChild(b);
        dots.appendChild(li);
      });
      viewer.appendChild(dots);
      var buttons = dots.querySelectorAll('button');
      var ticking = false;
      list.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = items[0].getBoundingClientRect().width || 1;
          var idx = Math.round(list.scrollLeft / w);
          buttons.forEach(function (btn, i) { btn.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        });
      }, { passive: true });
    });
  }

  /* ---------- Mobil-Menü ---------- */
  function initMenu(root) {
    (root || document).querySelectorAll('[data-se-menu]').forEach(function (menu) {
      if (menu.dataset.seMenuDone) return;
      menu.dataset.seMenuDone = '1';
      var summary = menu.querySelector('summary');
      function close() {
        menu.open = false;
        if (summary) summary.focus();
      }
      menu.querySelectorAll('[data-se-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
      menu.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.open) close(); });
      menu.addEventListener('toggle', function () {
        document.documentElement.style.overflow = menu.open ? 'hidden' : '';
        if (summary) summary.setAttribute('aria-label', menu.open ? 'Menü schließen' : 'Menü öffnen');
        if (menu.open) {
          var first = menu.querySelector('.se-menu__list a');
          if (first) first.focus();
        }
      });
    });
  }

  /* ---------- CTAs auf der eigenen Produktseite: zur Buy-Box scrollen statt neu laden ---------- */
  function initSamePageCta() {
    if (document.documentElement.dataset.seCtaDone) return;
    document.documentElement.dataset.seCtaDone = '1';
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.hash) return;
      var buy = document.querySelector('.se-pdp');
      if (!buy) return;
      e.preventDefault();
      var top = buy.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
      var submit = buy.querySelector('.product-form__submit');
      if (submit) setTimeout(function () { submit.focus({ preventScroll: true }); }, reduceMotion ? 0 : 500);
    });
  }

  /* ---------- Cookie-Einstellungen (Shopify Customer Privacy) ---------- */
  function initPrivacy(root) {
    (root || document).querySelectorAll('[data-se-privacy]').forEach(function (btn) {
      if (btn.dataset.sePrivacyDone) return;
      btn.dataset.sePrivacyDone = '1';
      btn.addEventListener('click', function () {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences();
        }
      });
    });
  }

  function initAll(root) {
    initGalleryDots(root);
    initMenu(root);
    initSamePageCta();
    initPrivacy(root);
    initReveal(root);
    initDelivery(root);
    initSticky(root);
    initBundles(root);
    initUpsellAdd();
    initCartOpenGuard();
    initTabs(root);
    initSlider(root);
    initVideo(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Warenkorb-Drawer wird nach „In den Warenkorb" neu gerendert: Liefertermin & Co. neu berechnen */
  function watchCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { initDelivery(drawer); }, 50);
    }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart); else watchCart();

  /* Theme-Editor: Sections neu initialisieren */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-se-panel]');
    if (panel) {
      var wrap = panel.closest('[data-se-tabs]');
      var idx = Array.prototype.indexOf.call(wrap.querySelectorAll('[data-se-panel]'), panel);
      var tab = wrap.querySelectorAll('[role="tab"]')[idx];
      if (tab) tab.click();
      var sum = panel.querySelector('[data-se-summary]');
      if (sum && sum.getAttribute('aria-expanded') !== 'true') sum.click();
    }
    var faq = e.target.tagName === 'DETAILS' ? e.target : null;
    if (faq) faq.open = true;
  });
})();
